export const notFoundStripeColors = ['#E2BF65', '#78BBB6', '#92B35F', '#C774AB', '#CE6983', '#527DA4'] as const;
